import { LOCATION_TYPES, Office, replaceLocationOrganizationLabel } from 'services/locations/locations.constant';
import { MultiCollapsedPanelData } from 'components/multi-collapsed-panel/multi-collapsed-panel.constants';
import { GlobalOrganizationsLabel } from 'features/global-organizations-setting-state/global-organizations-setting.constant';

export enum ORGANIZATION_LOCATION_ACTIONS {
  ADD_COUNTRY,
  DELETE_COUNTRY,

  ADD_REGION,
  EDIT_REGION,
  DELETE_REGION,

  ADD_OFFICE,
  EDIT_OFFICE,
  DELETE_OFFICE,
}

export const ORGANIZATION_LOCATION_ACTIONS_NAMES = {
  [ORGANIZATION_LOCATION_ACTIONS.ADD_COUNTRY]: 'Add Country',
  [ORGANIZATION_LOCATION_ACTIONS.DELETE_COUNTRY]: 'Delete',
  [ORGANIZATION_LOCATION_ACTIONS.ADD_REGION]: 'Add {region}',
  [ORGANIZATION_LOCATION_ACTIONS.EDIT_REGION]: 'Edit',
  [ORGANIZATION_LOCATION_ACTIONS.DELETE_REGION]: 'Delete',
  [ORGANIZATION_LOCATION_ACTIONS.ADD_OFFICE]: 'Add {office}',
  [ORGANIZATION_LOCATION_ACTIONS.EDIT_OFFICE]: 'Edit',
  [ORGANIZATION_LOCATION_ACTIONS.DELETE_OFFICE]: 'Delete',
};

export const ORGANIZATIONS_LOCATION_ACTIONS_ICONS = {
  [ORGANIZATION_LOCATION_ACTIONS.ADD_COUNTRY]: 'location',
  [ORGANIZATION_LOCATION_ACTIONS.DELETE_COUNTRY]: 'delete',
  [ORGANIZATION_LOCATION_ACTIONS.ADD_REGION]: 'location',
  [ORGANIZATION_LOCATION_ACTIONS.EDIT_REGION]: 'file-edit',
  [ORGANIZATION_LOCATION_ACTIONS.DELETE_REGION]: 'delete',
  [ORGANIZATION_LOCATION_ACTIONS.ADD_OFFICE]: 'location',
  [ORGANIZATION_LOCATION_ACTIONS.EDIT_OFFICE]: 'file-edit',
  [ORGANIZATION_LOCATION_ACTIONS.DELETE_OFFICE]: 'delete',
};

export const ORGANIZATION_LOCATION_ACTIONS_MODAL_BODY_TEXT = {
  [ORGANIZATION_LOCATION_ACTIONS.DELETE_COUNTRY]:
    'Are you sure you would like to delete this country? This will also delete any {region} and {office} associated with this country.',
  [ORGANIZATION_LOCATION_ACTIONS.DELETE_REGION]:
    'Are you sure you would like to delete this {region}? This will also delete any {office} associated with this {region}.',
  [ORGANIZATION_LOCATION_ACTIONS.DELETE_OFFICE]: 'Are you sure you would like to delete this {office}?',
};

export function makeActionsArr(actionsType: ORGANIZATION_LOCATION_ACTIONS[], labels: GlobalOrganizationsLabel) {
  return actionsType.reduce((actions, type) => {
    return [
      ...actions,
      {
        type,
        name: replaceLocationOrganizationLabel(ORGANIZATION_LOCATION_ACTIONS_NAMES[type], labels),
      },
    ];
  }, []);
}

export function makeOptionsArr(optionsType: ORGANIZATION_LOCATION_ACTIONS[]) {
  return optionsType.reduce((options, type) => {
    return [
      ...options,
      { id: type, title: ORGANIZATION_LOCATION_ACTIONS_NAMES[type], icon: ORGANIZATIONS_LOCATION_ACTIONS_ICONS[type] },
    ];
  }, []);
}

export interface LocationSettingResponse {
  rows: LocationCountryRow[];
}

interface LocationItem {
  locationTypeId: LOCATION_TYPES;
}

export interface LocationMultiCollapsedPanelData
  extends MultiCollapsedPanelData,
    Partial<LocationItem>,
    Partial<Office> {}

interface LocationOfficeRow extends LocationItem {
  id: number;
  name: string;
  address1: string;
  address2: string;
  postalCode: string;
}

interface LocationRegionRow extends LocationItem, LocationParentItem<LocationOfficeRow> {
  id: number;
  name: string;
}

export interface LocationCountryRow extends LocationItem, LocationParentItem<LocationRegionRow> {
  id: number;
  name: number;
}

interface LocationParentItem<T> {
  children: T[];
}

export const LOCATION_TYPES_OPTIONS = {
  [LOCATION_TYPES.COUNTRY]: makeOptionsArr([
    ORGANIZATION_LOCATION_ACTIONS.ADD_REGION,
    ORGANIZATION_LOCATION_ACTIONS.DELETE_COUNTRY,
  ]),
  [LOCATION_TYPES.REGION]: makeOptionsArr([
    ORGANIZATION_LOCATION_ACTIONS.EDIT_REGION,
    ORGANIZATION_LOCATION_ACTIONS.ADD_OFFICE,
    ORGANIZATION_LOCATION_ACTIONS.DELETE_REGION,
  ]),
  [LOCATION_TYPES.OFFICE]: makeOptionsArr([
    ORGANIZATION_LOCATION_ACTIONS.EDIT_OFFICE,
    ORGANIZATION_LOCATION_ACTIONS.DELETE_OFFICE,
  ]),
};
